export default "__VITE_ASSET__2f7d62f1__"